import { Controller } from "@hotwired/stimulus"

const carriesFiles = (event) => Array.from(event.dataTransfer?.types || []).includes("Files")

export default class extends Controller {
  static targets = ["input", "zone", "filename", "error"]
  static values = { rejectionMessage: String, multipleFilesMessage: String }

  connect() {
    this.preventPageNavigation = (event) => {
      if (carriesFiles(event)) event.preventDefault()
    }
    document.addEventListener("dragover", this.preventPageNavigation)
    document.addEventListener("drop", this.preventPageNavigation)
  }

  disconnect() {
    document.removeEventListener("dragover", this.preventPageNavigation)
    document.removeEventListener("drop", this.preventPageNavigation)
  }

  highlight(event) {
    event.preventDefault()
    this.zoneTarget.classList.add("is-dragover")
  }

  unhighlight(event) {
    event.preventDefault()

    if (event.type === "dragleave" && this.zoneTarget.contains(event.relatedTarget)) return

    this.zoneTarget.classList.remove("is-dragover")
  }

  drop(event) {
    event.preventDefault()
    this.unhighlight(event)

    const droppedFiles = Array.from(event.dataTransfer?.files || [])
    if (droppedFiles.length === 0) return

    const acceptedFile = droppedFiles.find((file) => this.acceptsFile(file))
    if (!acceptedFile) return this.rejectDrop()

    const transfer = new DataTransfer()
    transfer.items.add(acceptedFile)
    this.inputTarget.files = transfer.files

    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))

    if (droppedFiles.length > 1) this.noticeDiscardedFiles()
  }

  displaySelection() {
    const [selectedFile] = this.inputTarget.files
    this.filenameTarget.textContent = selectedFile ? selectedFile.name : ""
  }

  acceptsFile(file) {
    const accept = this.inputTarget.accept
    if (!accept) return true

    return accept
      .split(",")
      .map((acceptedType) => acceptedType.trim().toLowerCase())
      .filter(Boolean)
      .some((acceptedType) => {
        if (acceptedType.startsWith(".")) return file.name.toLowerCase().endsWith(acceptedType)
        if (acceptedType.endsWith("/*")) return file.type.startsWith(acceptedType.slice(0, -1))

        return file.type.toLowerCase() === acceptedType
      })
  }

  // Only one file can be imported, so say so instead of silently dropping the rest.
  noticeDiscardedFiles() {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = this.multipleFilesMessageValue
    this.errorTarget.classList.remove("error")
  }

  rejectDrop() {
    this.inputTarget.value = ""
    if (this.hasFilenameTarget) this.filenameTarget.textContent = ""
    this.disableSubmit()

    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = this.rejectionMessageValue
    this.errorTarget.classList.add("error")
  }

  disableSubmit() {
    const submitButton = this.element.closest("form")?.querySelector('[type="submit"]')
    if (submitButton) submitButton.disabled = true
  }
}
